var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"carousel",on:{"mouseenter":_vm.pauseAnimation,"mouseleave":_vm.resumeAnimation}},[_c('div',{staticClass:"slides",style:(_vm.slideStyle)},_vm._l((_vm.imagesWithClone),function(image,index){return _c('div',{key:index,staticClass:"slide"},[_c('img',{attrs:{"src":image,"alt":""}})])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }